import { useCallback } from 'react';
import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

interface RevokePayload {
  refresh_token?: string | null;
}

const useRevokeQuery = () => {
  const { mutateAsync, isLoading, isError } = useMutation((payload: RevokePayload) => api.post(API_URL.REVOKE, payload, {  }));

  const handleRevoke = useCallback(async (payload: RevokePayload) => {
    if (!payload?.refresh_token) {
      return;
    }

    try {
      await mutateAsync(payload);
    // eslint-disable-next-line no-empty, @typescript-eslint/no-unused-vars
    } catch (error) {}
  }, [mutateAsync]);

  return {
    handleRevoke,
    mutateAsync,
    isLoading,
    isError,
  };
};

export default useRevokeQuery;
